import { gsap } from 'gsap';
import { fadeInit, fadeEnter, fadeLeave } from '@/scripts/animations/fade';

export function loaderEnter(el) {
  const text = el.querySelector('.loader__text');
  const tl = gsap.timeline();

  fadeInit(text, { y: 40 });

  tl.addLabel('start')
    .add(fadeEnter(text), 'start');

  return tl;
}

export function loaderLeave(el) {
  const text = el.querySelector('.loader__text');
  const tl = gsap.timeline();

  tl.addLabel('start')
    .add(fadeLeave(text, { y: 0, scale: 1.5 }, 0, 1.2), 'start');

  return tl;
}
